export default {
  ACH: 'ACH',
  FWT: 'FWT',
};
